// store/modules/sidebar.js
const state = {
  items: [],
  footerItems: []
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_FOOTER_ITEMS(state, footerItems) {
    state.footerItems = footerItems
  }
}

const actions = {
  fetchSidebarItems({ commit }) {
    // Fetch items from an API or define them here
    const items = [
      { title: 'Dashboard', link: '/dashboard' },
      { title: 'Items', link: '/items' },
      { title: 'Reports', link: '/reports' },
      { title: 'Search', link: '/search' },
      { title: 'Tags', link: '/tags' },
      { title: 'Finances', link: '/finances' }
    ]
    const footerItems = ['Tips', 'Alerts', 'Settings']
    commit('SET_ITEMS', items)
    commit('SET_FOOTER_ITEMS', footerItems)
  }
}

export default {
  state,
  mutations,
  actions
}
